module.exports = __webpack_public_path__ + "static/media/apartment18.1e6b9458.jpg";